import './App.css';
import "primeicons/primeicons.css";
import "../node_modules/primeflex/primeflex.css";
import "primereact/resources/primereact.min.css";
import RouteConfig from "./navigation/RouteConfig";
import "primereact/resources/themes/saga-blue/theme.css";

function App() {
  return (
    <RouteConfig />
  );
}

export default App;
